import React from 'react'
import { ROUTES } from '../../constants/routes'
import { FeatureFlag } from '../FeatureFlag/FeatureFlag'
import { INavItemProps } from '../NavTabs/NavItem'
import { NavTabs } from '../NavTabs/NavTabs'

export const FinancialNavTabs = () => {
  const tabs: INavItemProps[] = [
    {
      id: ROUTES.FINANCIALS_ORDERS.split('/').pop() || '',
      to: ROUTES.FINANCIALS_ORDERS,
      children: 'Orders',
    },
    {
      id: ROUTES.FINANCIALS_REPORTS.split('/').pop() || '',
      to: ROUTES.FINANCIALS_REPORTS,
      children: 'Reports',
    },
    {
      id: ROUTES.FINANCIALS_TAX_RATES.split('/').pop() || '',
      to: ROUTES.FINANCIALS_TAX_RATES,
      children: 'Tax Rates',
    },
    {
      id: ROUTES.FINANCIALS_PAYOUTS.split('/').pop() || '',
      to: ROUTES.FINANCIALS_PAYOUTS,
      children: 'Payouts',
    },
    {
      id: ROUTES.FINANCIALS_COUPONS.split('/').pop() || '',
      to: ROUTES.FINANCIALS_COUPONS,
      children: (
        <>
          Coupons
          <FeatureFlag
            flagKey="discounts_enabled"
            fallback={
              <span className="badge rounded-pill text-bg-light text-capitalize ms-2">Upgrade</span>
            }
          />
        </>
      ),
    },
    {
      id: ROUTES.FINANCIALS_MEMBERSHIPS.split('/').pop() || '',
      to: ROUTES.FINANCIALS_MEMBERSHIPS,
      children: (
        <>
          Memberships
          <FeatureFlag
            flagKey={['sessions_enabled', 'memberships_enabled']}
            fallback={
              <span className="badge rounded-pill text-bg-light text-capitalize ms-2">Upgrade</span>
            }
          />
        </>
      ),
    },
  ]
  return <NavTabs options={tabs} />
}
